<!--
 * 下拉框组件
 * @author 滕威
 * @time 2019-12-6
 *
-->
<!-- 模板(html)代码 start -->
<template>
  <el-select
    ref="select"
    v-model="value"
    :disabled="disabled"
    :clearable="clearable"
    :filterable="filterable"
    placeholder="请选择"
    @change="handleFilter"
    @focus="fun_SelectFocus"
    @blur="fun_SelectBlur"
    @visible-change="fun_VisibleChange"
    @clear="fun_Clear"
    :multiple="multipleValue"
    :collapse-tags="collapseTags"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.name"
      :value="item.value"
    >
      <span
        v-if="item.label !== undefined && item.label !== ''"
        style="float: left"
        >{{ item.name }}</span
      >
      <span
        v-if="item.label !== undefined && item.label !== ''"
        style="float: right; color: #8492a6; font-size: 13px"
        >{{ item.label }}</span
      >
    </el-option>
  </el-select>
</template>
<!-- 模板(html)代码 end -->

<!-- JS代码 start -->
<script>
// 引入axios方法
import { fun_PostAction } from "@/api";
/**
 * 组件默认导出属性
 * @author 滕威
 */
export default {
  // 初始化数据对象
  data() {
    return {
      options: [], // 下拉框数组
      value: null, // 下拉框绑定的value值
      formDate: {
        code: null, // 子组件value存放对象
        options: [], // 下拉框数组
      }
    };
  },

  // 接收来自父组件的数据
  props: {
    // 请求字典参数对象
    queryParams: {
      required: true
    },
    // 父组件绑定值
    codeSting: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multipleValue: {
      type: Boolean,
      default: false
    },
    // 多选时是否将选中值按文字的形式展示
    collapseTags: {
      type: Boolean,
      default: false
    },
    // 清除
    clearable: {
      type: Boolean,
      default: true
    },
    // 可搜索
    filterable: {
      type: Boolean,
      default: true
    },
    optionData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 下拉框字段名
    field: {
      type: String,
      default: null
    },
    // 列表嵌套下拉框获取列表数据的行下标
    index: {
      type: Number,
      default: 0
    }
  },

  // 监听
  watch: {
    // 监听父组件绑定值
    codeSting: {
      // handler监听改变之后的值、改变之前的值
      handler(newName) {
        // 如果有改变的值
        if (newName) {
          // 将改变的值赋值给下拉框绑定的value值
          this.value = newName;
        } else {
          this.value = null;
        }
      },
      immediate: true, // 立即执行
      deep: false // 不需要深度监听
    },
    // 监听字典请求参数对象
    queryParams: {
      handler(newVal) {
        if (newVal) {
          // 赋值
          this.queryParams = newVal;
          // 请求字典
          this.fun_GetDic();
        }
      },
      immediate: true, // 立即执行
      deep: true // 需要深度监听
    }
  },

  // 模板编译完成
  mounted() {
    // 调用字典请求方法
    this.fun_GetDic();
  },

  // 自定义事件
  methods: {
    /**
     * 下拉框change事件
     * @author 滕威
     */
    handleFilter() {
      // 将下拉框选择的value值赋值给formDate.code
      this.formDate.code = this.value;
      this.formDate.options = this.options;
      // $emit事件将选择的下拉框value值发送给调用change事件者
      this.$emit("change", this.formDate, this.field, this.options, this.index);
    },

    /**
     * 下拉框获取焦点事件
     * @author 滕威
     */
    fun_SelectFocus(e) {
      // $emit事件将选择的下拉框value值发送给调用blur事件者
      this.$emit("focus", e, this.field);
    },
    /**
     * 下拉框失去焦点事件
     * @author 滕威
     */
    fun_SelectBlur(e) {
      // $emit事件将选择的下拉框value值发送给调用blur事件者
      this.$emit("blur", e, this.field);
    },
    /**
     * 下拉框打开关闭事件
     * @author 滕威
     */
    fun_VisibleChange(e) {
      // $emit事件将选择的下拉框value值发送给调用blur事件者
      this.$emit("fun_VisibleChange", e, this.field);
    },
    /**
     * 下拉框清空事件
     * @author 滕威
     */
    fun_Clear() {
      // $emit事件将选择的下拉框value值发送给调用clear事件者
      this.$emit("clear", this.field);
    },
    /**
     * 请求字典方法
     * @author 滕威
     */
    async fun_GetDic() {
      // 判断传值不为空则不进行共通查询
      if (this.optionData.length == 0) {
        // 设置url
        var url = "";
        // 如果url不为空
        if (this.queryParams.url != "" && this.queryParams.url != null) {
          // 设置url
          url = this.queryParams.url;
        } else {
          url = "/combobox";
        }
        // 调用字典axios方法
        let res = await fun_PostAction(url, this.queryParams);
        // 判断请求是否成功
        if (res.data.result) {
          // 请求成功的场合
          // 将解析的data数组赋值给下拉框
          this.options = res.data.data;
        }
      } else {
        // 将解析的data数组赋值给下拉框
        this.options = this.optionData;
      }
    }
  }
};
</script>
<!-- JS代码 end -->
